import {useCallback, useEffect, useRef, useState} from 'react';
import axios from 'axios';
const errorMessage = error => {
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' ? detail : detail?.message || error.response?.data?.message || 'Wache derzeit nicht erreichbar. Bitte erneut versuchen.';
};
// One outstanding read per panel. Aborts and generation checks also protect against adapters ignoring signals.
export function useRequest() {
  const current = useRef(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const cancel = useCallback(() => {current.current?.abort(); current.current=null;setBusy(false);setError('');}, []);
  useEffect(() => cancel, [cancel]);
  const run = useCallback(async (operation, accept) => {
    cancel(); const controller=new AbortController(); current.current=controller; setBusy(true); setError('');
    try {const result=await operation(controller.signal); if(current.current===controller) accept(result.data);}
    catch(e) {if(current.current===controller && !controller.signal.aborted) setError(errorMessage(e));}
    finally {if(current.current===controller) {setBusy(false); current.current=null;}}
  }, [cancel]);
  return {run, cancel, busy, error};
}
export function useEnabled(apiBase) {
  const [enabled,setEnabled]=useState(false);
  useEffect(()=>{const c=new AbortController(); axios.get(`${apiBase}/network/status`,{signal:c.signal}).then(r=>{if(!c.signal.aborted)setEnabled(r.data.enabled===true);}).catch(()=>{}); return ()=>c.abort();},[apiBase]);
  return enabled;
}
